import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableBackgroundImport = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableBackgroundImport);
};
